module.exports = __webpack_public_path__ + "img/card_box.ca159785.png";